import { createRoute } from '@tanstack/react-router';
import { IconActivity, IconPresentationAnalytics, IconUsers } from '@tabler/icons-react';
import type { Zone } from '@hana/shell';
import type { ApiRoutes } from '@hana/data';
import { bodApiRoute } from './bod/apiRoute';
import { COST, DN, JDN, REV } from './bod/data';
import { Bod, type TabKey } from './bod/Bod';

// Vùng HANA Lys (/lys): báo cáo điều hành BOD, tách khỏi Ezy (QĐ anh David, issue issue 1160; board Mint-BOD · Mint-BOD-Phone · Mint-BOD-1920).
// Tiền chỉ người có quyền money (xem access.ts). Tab tiền (Tài chính · Thuế & VAT · Job lỗ) ở bod/MoneyTabs.tsx, chỉ hiện với money=view.
const TABS: readonly TabKey[] = ['ov', 'fin', 'tax', 'ops', 'svc', 'loss', 'hr', 'evt', 'sla', 'fleet'];

export const zone: Zone = {
  key: 'lys',
  name: 'HANA Lys',
  top: [],
  nav: [
    { key: 'dh', label: 'Báo cáo điều hành', icon: IconPresentationAnalytics, items: [['ov', 'Tổng quan', '/lys'], ['fin', 'Tài chính', '/lys/fin'], ['tax', 'Thuế & VAT', '/lys/tax'], ['ops', 'Kinh doanh', '/lys/ops'], ['svc', 'Hiệu suất dịch vụ', '/lys/svc'], ['loss', 'Lợi nhuận theo lô', '/lys/loss']].map(([key, label, to]) => ({ key: key!, label: label!, to: to! })) },
    { key: 'ng', label: 'Con người', icon: IconUsers, items: [{ key: 'hr', label: 'Nhân sự & năng suất', to: '/lys/hr' }, { key: 'evt', label: 'Sai sót & khen thưởng', to: '/lys/evt' }] },
    { key: 'vh', label: 'Vận hành', icon: IconActivity, items: [{ key: 'sla', label: 'SLA mail & chat', to: '/lys/sla' }, { key: 'fleet', label: 'Đội xe', to: '/lys/fleet' }] },
  ],
  fixtures: (register) => register('bodMonth', ['2025-11', '2025-12', '2026-01', '2026-02', '2026-03', '2026-04', '2026-05', '2026-06', '2026-07', '2026-08', '2026-09', '2026-10'].map((id, i) => ({ id, docs: DN[i]!, jdn: JDN[i]!, rev: REV[i]!, cost: COST[i]! }))),
  routes: (parent) => TABS.map((k) => createRoute({ getParentRoute: () => parent, path: k === 'ov' ? '/' : `/${k}`, component: () => <Bod tab={k} /> })),
};

/** Route api của Lys (BOD · /v1/finance/bod). Hub gộp vào API_ROUTES ở apps/hub/src/api-routes.ts (luồng A). */
export const apiRoutes: ApiRoutes = { bodMonth: bodApiRoute };
